/**
 * Function to get base url with query params
 *
 * @param { string } baseUrl - Base url
 * @param { IPaginationQuery } queryFilters - Filters to send as query
 * @returns { string } - Final url
 */

import { IPaginationQuery } from "Interfaces/PaginatedList";
import { buildQueryParam } from "./filtering";

export const getQueryParams = <T>(
  baseUrl: string,
  queryFilters: IPaginationQuery<T>
): string => {
  const defaultQueryParams: Record<string, string> = {
    pageIndex: String(queryFilters.pageIndex),
    pageSize: String(queryFilters.pageSize),
    filters: JSON.stringify(
      getValuesOfFiltersForPaginated(queryFilters.filters)
    ),
  };

  if (queryFilters.sort.length > 0) {
    defaultQueryParams.sortField = String(queryFilters.sort[0].field);
    defaultQueryParams.sortOrder = String(queryFilters.sort[0].sort);
  }

  const queryString = new URLSearchParams(defaultQueryParams).toString();
  return `${baseUrl}?${queryString}`;
};

export const getFiltersParams = <T>(baseUrl: string, queryFilters: T) => {
  const defaultQueryParams: Record<string, any> =
    getValuesOfFiltersForPaginated(queryFilters);

  const queryString = getURLSearchParams(defaultQueryParams);
  return `${baseUrl}?${queryString}`;
};

const getValuesOfFiltersForPaginated = (filters: any) => {
  const filtersFiltered = Object.entries(filters).reduce(
    (accumulator: any, [key, value]) => {
      const val = value as any;
      accumulator[key] = val?.value;
      return accumulator;
    },
    {}
  );

  return filtersFiltered;
};

const getURLSearchParams = (searchParams: any) => {
  const searchParamsFiltered = Object.entries(searchParams).reduce(
    (accumulator, [key, value]) => {
      accumulator = accumulator + buildQueryParam(key, value);
      return accumulator;
    },
    ""
  );

  return searchParamsFiltered;
};
